import React from 'react'
import { Grid, Menu } from 'semantic-ui-react'
import { version } from '../../../../package.json'
import { COPYRIGHT } from 'Lib'

export default (props) => (
    <Menu secondary fixed="bottom" style={{ height: '55px' }}>
        <Grid style={{ margin: '1em 0em 0em', backgroundColor: "#333", color: '#ccc', width: '100%', textAlign: 'right' }}>
            <Grid.Row>
                <Grid.Column width={'9'}>
                    {/* © 2019 BAINISYS */}
                    {props.setting? props.setting.backendFooter : COPYRIGHT}
                </Grid.Column>
                <Grid.Column width={'7'}>
                    <div>Version
                    {' ' + version}
                    </div>
                </Grid.Column>
            </Grid.Row>

        </Grid>
    </Menu>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Footer.js